/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TargetNoteMessagesPageModel } from '../../models/target-note-messages-page-model';

export interface GetTargetNoteMessages$Params {
  targetId?: number;
  beforeMessageId?: number;
  pageSize?: number;
}

export function GetTargetNoteMessages(http: HttpClient, rootUrl: string, params?: GetTargetNoteMessages$Params, context?: HttpContext): Observable<StrictHttpResponse<TargetNoteMessagesPageModel>> {
  const rb = new RequestBuilder(rootUrl, GetTargetNoteMessages.PATH, 'get');
  if (params) {
    rb.query('targetId', params.targetId, {});
    rb.query('beforeMessageId', params.beforeMessageId, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TargetNoteMessagesPageModel>;
    })
  );
}

GetTargetNoteMessages.PATH = '/api/Staff/GetTargetNoteMessages';
